import React, { useEffect } from "react";
import { Box } from "@mui/material";
import Alert from "@mui/material/Alert";
import { string, bool, object } from "prop-types";

import ReportSnapshotHeader from "./ReportSnapshotHeader";
import ReportSnapshotBody from "./ReportSnapshotBody";
import ProgressIndicator from "../../ProgressIndicator";
import { connectToState } from "../../../redux/connect-api";
import { analysesLoadingSelector, reportSnapshotSelector } from "../../../selectors";
import { trackPageView } from "../../../hooks/usePageView";
import { userIsTrialSubscriberSelector } from "../../../selectors/userProfile";
import { isDataSuppressibleForTrial } from "../../../config";
import DataAccessAlert from "../../DataAccessAlert";

const getTitleAndYearFromReport = (report) => {
  const currentCondition = report.specific_conditions[0] || "";
  let year = null;
  if (report.date_of_review) {
    year = new Date(report.date_of_review).getFullYear();
  }
  return { title: currentCondition, year };
};

const ReportSnapshot = (props) => {
  const { report = {}, analysesLoading, subscriptionIsTrial } = props;

  useEffect(() => {
    if (!report || Object.keys(report).length === 0) return;
    const { title, year } = getTitleAndYearFromReport(report);
    trackPageView(`Report Snapshot: ${title} (${year})`);
  }, [report]);

  if (analysesLoading) {
    return <ProgressIndicator active={analysesLoading} />;
  }

  // If report was not loaded or found indicate in UI
  if (!report || Object.keys(report).length === 0) {
    return (
      <Box sx={{ mt: 4, width: "100%" }}>
        <Box sx={{ mx: 3 }}>
          <Alert severity="warning">Report Snapshot could not be found</Alert>
        </Box>
      </Box>
    );
  }

  // If user does not have access to report
  const dateOfReview = new Date(report?.date_of_review);
  if (dateOfReview && subscriptionIsTrial && isDataSuppressibleForTrial(dateOfReview)) {
    return (
      <Box sx={{ mt: 4, width: "100%" }}>
        <Box sx={{ mx: 3 }}>
          <DataAccessAlert label="This report snapshot is" />
        </Box>
      </Box>
    );
  }

  let relatedDrugs = report.drugs || [];
  const currentCondition = report.specific_conditions[0] || "";
  let date = null;
  if (report.date_of_review) {
    date = new Date(report.date_of_review);
  }
  return (
    <>
      <ReportSnapshotHeader drugs={relatedDrugs} condition={currentCondition} date={date} />
      <ReportSnapshotBody report={report} />
    </>
  );
};

ReportSnapshot.propTypes = {
  activeReportId: string,
  report: object,
  analysesLoading: bool.isRequired,
  subscriptionIsTrial: bool,
};

const mapStateToProps = (state, ownProps) => {
  return {
    report: reportSnapshotSelector(state, ownProps),
    analysesLoading: analysesLoadingSelector(state, ownProps),
    subscriptionIsTrial: userIsTrialSubscriberSelector(state),
  };
};

export default connectToState(mapStateToProps)(ReportSnapshot);
